const websiteUrl = 'https://www.moonpig.com'
const pattern = new RegExp(`^${websiteUrl.replace(/\//g, '\\/')}/?`, 'g')

// Nb. wherever possible this should be avoided
// i.e. fix the source data
export const absToRelUrl = (url: string) => url.replace(pattern, '/')
